import * as basketAPI from "../../api/basket";
import { IUserConfigurableBundle } from "../../models/catalogue";

export const loadUserConfigurableBundles = async (): Promise<
    IUserConfigurableBundle[]
> => {
    // Load the basket
    const basket = await basketAPI.load();
    // Load configurable bundles for the given basket
    return basketAPI.listUserConfigurableBundles(basket);
};
